import { AfterViewInit, ChangeDetectionStrategy, Component, OnDestroy, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject, Subscription } from 'rxjs';
import { debounceTime, map, switchMap } from 'rxjs/operators';
import { SpecificationGroupSearchProductResponseOfProductCardModel } from 'src/business/services/client.generated';
import { ContentAndProductSearchResolver, SearchResult } from 'src/core-lib/navigation/services/content.resolver';
import { OverlayService } from 'src/layout/overlay/services/overlay.service';
import { PageUtils } from 'src/utils/storage.util';
import { UrlUtil } from 'src/utils/url.util';


type ExtendedSpecificationGroupSearchProductResponseOfProductCardModel = SpecificationGroupSearchProductResponseOfProductCardModel & { state?: string }

@Component({
    selector: 'app-overlay-search',
    templateUrl: './overlay-search.component.html',
    styleUrls: ['./overlay-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ContentAndProductSearchResolver]
})
export class OverlaySearchComponent implements OnDestroy, AfterViewInit {
    static get OVERLAY_SEARCH() {
        return window['overlaySearch'];
    };
    templates: { [key: string]: TemplateRef<any> };
    results$: Observable<SearchResult>;
    private _subscriptions: Array<Subscription>;
    private _makeSearch: Subject<void>;
    private _searchUrl: URL;


    constructor(
        private overlaySerivce: OverlayService,
        private productSearchService: ContentAndProductSearchResolver,
        private router: Router,
    ) {
        this._subscriptions = [];
        this._makeSearch = new Subject<void>();
        this._searchUrl = PageUtils.loadSearchLink();

        this.results$ = this._makeSearch.pipe(
            debounceTime(525),
            map(async () => {
                let data = new FormData(OverlaySearchComponent.OVERLAY_SEARCH);
                data.set('size', '5')
                let model = this.productSearchService.formModel(data);
                let result = await this.productSearchService.search(model);
                let copy = structuredClone(result) as ExtendedSpecificationGroupSearchProductResponseOfProductCardModel;
                if (data.get(UrlUtil.SEARCH_PREFIX).toString() == '')
                    copy.state = 'no-search';
                return copy;
            }),
            switchMap(resp => resp)
        );
    }
    ngAfterViewInit(): void {
        window['SEARCH-overlay-input'].focus();
    }

    ngOnDestroy(): void {
        this._subscriptions.forEach(s => {
            if (s != null && !s.closed)
                s.unsubscribe();
        })
    }

    searchByFormData() {
        this._makeSearch.next()
    }

    goToSearch() {
        this.close();
        let searchString = new FormData(OverlaySearchComponent.OVERLAY_SEARCH).get(UrlUtil.SEARCH_PREFIX).toString();
        let replaceUrl = new URL(window.location.href).searchParams.get(UrlUtil.SEARCH_PREFIX) !== searchString;
        if (searchString.trim().length > 0)
            this._searchUrl.searchParams.set(UrlUtil.SEARCH_PREFIX, searchString);
        else
            this._searchUrl.searchParams.delete(UrlUtil.SEARCH_PREFIX);
        this.router.navigateByUrl(this._searchUrl.pathname + this._searchUrl.search, { replaceUrl });
    }

    close() {
        this.overlaySerivce.close();
        setTimeout(() => {
            new FormData(OverlaySearchComponent.OVERLAY_SEARCH).set(UrlUtil.SEARCH_PREFIX, '');
        }, 200);
    }
}
